import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducers'

const useFiltersCount = (searchId: string) => {
  const filters = useSelector((state: AppState) => state.searchbar.filters[searchId] ?? {})
  const sorting = useSelector((state: AppState) => state.searchbar.sorting[searchId])
  let filtersAppliedCount = 0
  let sortingAppliedCount = Number(!!sorting)
  Object.values(filters).forEach(filter => {
    if (filter) filtersAppliedCount++
  })

  return {
    filtersAppliedCount,
    sortingAppliedCount,
    combinedAppliedCount: filtersAppliedCount + sortingAppliedCount,
  }
}

export default useFiltersCount
